/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SearchCategory } from './SearchCategory';
import {
    SearchCategoryFromJSON,
    SearchCategoryFromJSONTyped,
    SearchCategoryToJSON,
    SearchCategoryToJSONTyped,
} from './SearchCategory';
import type { SearchResultItemDto } from './SearchResultItemDto';
import {
    SearchResultItemDtoFromJSON,
    SearchResultItemDtoFromJSONTyped,
    SearchResultItemDtoToJSON,
    SearchResultItemDtoToJSONTyped,
} from './SearchResultItemDto';
import type { SearchPagedResponseDtoTotals } from './SearchPagedResponseDtoTotals';
import {
    SearchPagedResponseDtoTotalsFromJSON,
    SearchPagedResponseDtoTotalsFromJSONTyped,
    SearchPagedResponseDtoTotalsToJSON,
    SearchPagedResponseDtoTotalsToJSONTyped,
} from './SearchPagedResponseDtoTotals';

/**
 * 
 * @export
 * @interface SearchPagedResponseDto
 */
export interface SearchPagedResponseDto {
    /**
     * 
     * @type {Array<SearchResultItemDto>}
     * @memberof SearchPagedResponseDto
     */
    items?: Array<SearchResultItemDto> | null;
    /**
     * 
     * @type {number}
     * @memberof SearchPagedResponseDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchPagedResponseDto
     */
    pageIndex?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchPagedResponseDto
     */
    pageSize?: number;
    /**
     * 
     * @type {string}
     * @memberof SearchPagedResponseDto
     */
    query: string | null;
    /**
     * 
     * @type {SearchCategory}
     * @memberof SearchPagedResponseDto
     */
    category: SearchCategory;
    /**
     * 
     * @type {SearchPagedResponseDtoTotals}
     * @memberof SearchPagedResponseDto
     */
    totals: SearchPagedResponseDtoTotals | null;
}



/**
 * Check if a given object implements the SearchPagedResponseDto interface.
 */
export function instanceOfSearchPagedResponseDto(value: object): value is SearchPagedResponseDto {
    if (!('query' in value) || value['query'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('totals' in value) || value['totals'] === undefined) return false;
    return true;
}

export function SearchPagedResponseDtoFromJSON(json: any): SearchPagedResponseDto {
    return SearchPagedResponseDtoFromJSONTyped(json, false);
}

export function SearchPagedResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchPagedResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(SearchResultItemDtoFromJSON)),
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'pageIndex': json['pageIndex'] == null ? undefined : json['pageIndex'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'query': json['query'],
        'category': SearchCategoryFromJSON(json['category']),
        'totals': SearchPagedResponseDtoTotalsFromJSON(json['totals']),
    };
}

export function SearchPagedResponseDtoToJSON(json: any): SearchPagedResponseDto {
    return SearchPagedResponseDtoToJSONTyped(json, false);
}

export function SearchPagedResponseDtoToJSONTyped(value?: SearchPagedResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(SearchResultItemDtoToJSON)),
        'totalCount': value['totalCount'],
        'pageIndex': value['pageIndex'],
        'pageSize': value['pageSize'],
        'query': value['query'],
        'category': SearchCategoryToJSON(value['category']),
        'totals': SearchPagedResponseDtoTotalsToJSON(value['totals']),
    };
}

